import React, { ReactNode } from "react";
// External dependencies
import classNames from "classnames";
import { MainContainer } from "../../../assets/css/styledComponents/MainContainer";
import { Helmet } from "react-helmet";

// Define prop types for Wrapper component
interface WrapperProps {
  className?: string;
  subClassName?: string;
  navUrl: string;
  children: ReactNode;
  customStyle?: React.CSSProperties;
}

const Wrapper: React.FC<WrapperProps> = ({
  className,
  subClassName,
  navUrl,
  children,
  customStyle
}) => {
  // Combining default and additional classes for the main wrapper
  const MainWrapper = classNames(
    "m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body",
    className
  );

  // Combining default and additional classes for the sub wrapper
  const SubWrapper = classNames(
    "m-grid__item m-grid__item--fluid m-wrapper",
    subClassName
  );

  return (
    <MainContainer className={MainWrapper}>
      <Helmet>
        <title>{navUrl}</title>
      </Helmet>
      <div style={{ height: "", margin: 0, ...customStyle }} className={SubWrapper}>
        {children}
      </div>
    </MainContainer>
  );
};

export default Wrapper;
